<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>First Name</label>
                  <input type="text" v-model="user.first_name" />
                </div>

                <div class="form-group">
                  <label>Email</label>
                  <input type="text" v-model="user.email" />
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <div class="pass-group">
                    <input v-if="showPassword" type="text" class="pass-input" v-model="user.password" />
                    <input v-else type="password" class="pass-input" v-model="user.password" />
                    <span class="fas toggle-password" @click="toggleShow" :class="{
                      'fa-eye': showPassword,
                      'fa-eye-slash': !showPassword,
                    }"></span>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Last Name</label>
                  <input type="text" v-model="user.last_name" />
                </div>
                <div class="form-group">
                  <label>Role</label>
                  <vue-select :options="adminRoles" v-model="user.role_id" placeholder="Select Role" />
                </div>
                <div class="form-group">
                  <label>Confirm Password</label>
                  <div class="pass-group">
                    <input v-if="showPassword1" type="text" class="pass-input" v-model="password1" />
                    <input v-else type="password" class="pass-input" v-model="password1" />
                    <span class="fas toggle-password" @click="toggleShow1" :class="{
                      'fa-eye': showPassword1,
                      'fa-eye-slash': !showPassword1,
                    }"></span>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label> Profile Picture</label>
                  <div class="image-upload image-upload-new">
                    <img v-if="image_preview" style="
                        position: absolute;
                        height: 100%;
                        width: 100%;
                        object-fit: contain;
                        opacity: 0.5;
                      " :src="image_preview" />
                    <input type="file" @input="pickFile($event.target)" />
                    <div class="image-uploads">
                      <img src="../../../assets/img/icons/upload.svg" alt="img" />
                      <h4>Drag and drop a file to upload</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-12">
                <a @click="addAdmin" href="javascript:void(0);" class="btn btn-submit me-2">Submit</a>
                <a href="javascript:void(0);" class="btn btn-cancel">Cancel</a>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import { router } from "@/router";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      title: "Admin Management",
      title1: "Add/Update User",
      showPassword: false,
      showPassword1: false,
      password: null,
      password1: null,
      adminRoles: [],
      image_preview: null,
      user: {
        email: null,
        first_name: null,
        last_name: null,
        profile_picture: null,
        password: null,
        role_id: null,
      },
    };
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
  },
  methods: {
    ...mapActions({
      _getAdminRole: "adminRole/get",
      _addAdmin: "admin/add",
    }),
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },
    getAdminRole() {
      this._getAdminRole().then((response) => {
        this.adminRoles = response.data.data.map((adminRole) => {
          return {
            text: adminRole.name,
            id: adminRole.id,
          };
        });
      });
    },
    pickFile(event) {
      let file = event.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image_preview = e.target.result;
      };

      this.user.profile_picture = file;
      reader.readAsDataURL(file);
    },
    addAdmin() {
      this._addAdmin({ payload: this.user })
        .then((response) => {
          Swal.fire({
            title: "Admin Added",
            icon: "success",
          });
          router.push({ name: "admin" });
        })
        .catch((error) => {
          Swal.fire({
            title: error.response.data.message,
            icon: "error",
          });
        });
      Swal.fire({
        title: "Adding Admin",
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        html: `<div class="spinner-border text-warning" role="status"></div>`,
      });
    },
  },
  mounted() {
    this.getAdminRole();
  },
  name: "newuser",
};
</script>
